import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
})
export class SkeletonComponent {
  @Input() width: string = '100vw';
  @Input() height: string = '5vh';
  @Input() borderRadius: string = '1vw';
  @Input() marginBottom: string = '2vh';
}
